import React, { useState, useEffect } from 'react';
import { Check, CheckCircle2 } from 'lucide-react';
import { isVideoWatched, toggleWatchedStatus } from './watchedManager';

interface WatchedButtonProps {
  videoId: string;
}

export default function WatchedButton({ videoId }: WatchedButtonProps) {
  const [watched, setWatched] = useState(false);

  useEffect(() => {
    setWatched(isVideoWatched(videoId));

    const handleUpdate = () => {
      setWatched(isVideoWatched(videoId));
    };

    window.addEventListener('doisplay_watched_updated', handleUpdate);
    return () => window.removeEventListener('doisplay_watched_updated', handleUpdate);
  }, [videoId]);

  const handleToggle = (e: React.MouseEvent) => {
    e.stopPropagation();
    const newState = toggleWatchedStatus(videoId);
    setWatched(newState);
  };

  return (
    <button
      onClick={handleToggle}
      title={watched ? "Marcado como Assistido" : "Marcar como Assistido"}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        backgroundColor: watched ? 'rgba(34, 197, 94, 0.2)' : 'rgba(94, 83, 83, 0.1)',
        color: watched ? '#22c55e' : '#746d6d',
        border: `1px solid ${watched ? '#22c55e' : 'rgba(255, 255, 255, 0.2)'}`,
        padding: '12px 15px',
        borderRadius: '8px',
        cursor: 'pointer',
        fontWeight: 'bold',
        fontSize: '12px',
        backdropFilter: 'blur(4px)',
        transition: 'all 0.2s'
      }}
    >
      {watched ? <CheckCircle2 size={16} color="#22c55e" /> : <Check size={16} />}
      {watched ? 'Assistido' : 'Marcar como Assistido'}
    </button>
  );
}